// React
import React from "react";
// React
// CSS
import styles from "./Spinner.module.css";
// CSS

type SpinnerProps = {
  className?: string;
};

const Spinner: React.FunctionComponent<SpinnerProps> = ({ className }) => {
  return <span className={`${styles.loader} ${className}`}></span>;
};

export default Spinner;
